export type WizardOperationType = 'split' | 'merge' | 'split_and_merge' | 'redistribution';

export interface InferOperationInput {
    sourceCount: number;
    destinations: { receivesFrom: { sourceFishGroupId: number }[] }[];
}

/**
 * Mirror of the backend `inferOperationType`. Returns the operation type that
 * the backend will record for this shape. Falls back to `merge` for the
 * degenerate (S=1, D=1) case — same behaviour as the backend default branch.
 */
export function inferOperationType(input: InferOperationInput): WizardOperationType {
    const { sourceCount, destinations } = input;
    const D = destinations.length;

    if (sourceCount === 1 && D >= 2) return 'split';
    if (sourceCount >= 2 && D === 1) return 'merge';
    if (sourceCount >= 2 && D >= 2) {
        const destsWithMultipleInflows = destinations.filter(
            (d) => d.receivesFrom.length >= 2
        ).length;
        return destsWithMultipleInflows <= 1 ? 'split_and_merge' : 'redistribution';
    }
    return 'merge';
}
